import { lefttimelineline, righttimelineline, leftperiodcol, rightperiodcol, SetSpaceHeight, SetPeriodSpace } from "./timeline.js";

function revertLeft() {
  lefttimelineline.style.flex = 1;
  lefttimelineline.style.marginRight = "0";
  leftperiodcol.style.display = "";
  void leftperiodcol.offsetHeight;
  leftperiodcol.style.flex = 1;
  leftperiodcol.style.marginLeft = "2px";
  leftperiodcol.style.marginRight = "-4px";
  // visszaállítássa a bal oldalnak, ha azt már becsuktuk
  const item = document.querySelectorAll(`.date-middle`);
  item.forEach((item) => {
    const left = item.previousElementSibling;
    if (item.nextElementSibling.children[0].children.length == 0) {
      item.parentElement.style.height = "";
      item.parentElement.style.margin = "";
      const space = item.parentElement.previousElementSibling;
      if (space) {
        SetSpaceHeight(space);
      }
    }
    left.style.display = "block";
    void left.offsetHeight;
    left.style.flex = 1;
  });
  const perioditems = document.querySelectorAll(`.period-space`);
  perioditems.forEach((item) => {
    SetPeriodSpace(item);
  });
}
function revertRight() {
  righttimelineline.style.flex = 1;
  lefttimelineline.style.marginLeft = "0";
  rightperiodcol.style.display = "";
  void rightperiodcol.offsetHeight;
  rightperiodcol.style.flex = 1;
  rightperiodcol.style.marginRight = "2px";
  rightperiodcol.style.marginLeft = "-4px";
  const items = document.querySelectorAll(`.date-middle`);
  items.forEach((item) => {
    const right = item.nextElementSibling;
    if (item.previousElementSibling.children[0].children.length == 0) {
      item.parentElement.style.height = "";
      item.parentElement.style.margin = "";
      const space = item.parentElement.previousElementSibling;
      if (space) {
        SetSpaceHeight(space);
      }
    }
    right.style.display = "block";
    void right.offsetHeight;
    right.style.flex = 1;
  });
  const perioditems = document.querySelectorAll(`.period-space`);
  perioditems.forEach((item) => {
    SetPeriodSpace(item);
  });
}
function fullLeft() {
  righttimelineline.style.flex = 0;
  lefttimelineline.style.marginRight = "4px";
  rightperiodcol.style.flex = 0;
  leftperiodcol.style.marginRight = "4px";
  setTimeout(() => {
    rightperiodcol.style.display = "none";
  }, 1000);
  const items = document.querySelectorAll(`.date-middle`);
  items.forEach((item) => {
    const right = item.nextElementSibling;
    if (item.previousElementSibling.children[0].children.length == 0 && !item.classList.contains("period-identity-left")) {
      item.parentElement.style.height = "0px";
      item.parentElement.style.margin = "0px";
      const space = item.parentElement.previousElementSibling;
      if (space) {
        SetSpaceHeight(space);
      }
    }
    right.style.flex = 0;
    setTimeout(() => {
      right.style.display = "none";
    }, 1000);
  });
  const perioditems = document.querySelectorAll(`.left-period-space`);
  perioditems.forEach((item) => {
    SetPeriodSpace(item);
  });
}
function fullRight() {
  // minden igazítás beállítása
  lefttimelineline.style.flex = 0;
  lefttimelineline.style.marginLeft = "4px";
  leftperiodcol.style.flex = 0;
  rightperiodcol.style.marginLeft = "4px";
  setTimeout(() => {
    leftperiodcol.style.display = "none";
  }, 1000);
  const items = document.querySelectorAll(`.date-middle`);
  items.forEach((item) => {
    const left = item.previousElementSibling;
    if (item.nextElementSibling.children[0].children.length == 0 && !item.classList.contains("period-identity-right")) {
      item.parentElement.style.height = "0px";
      item.parentElement.style.margin = "0px";
      const space = item.parentElement.previousElementSibling;
      if (space) {
        SetSpaceHeight(space);
      }
    }
    left.style.flex = 0;
    setTimeout(() => {
      left.style.display = "none";
    }, 1000);
  });
  const perioditems = document.querySelectorAll(`.right-period-space`);
  perioditems.forEach((item) => {
    SetPeriodSpace(item);
  });
}
export function animationManager(a) {
  switch (a) {
    case "visszajobb":
      revertRight();
      break;
    case "visszabal":
      revertLeft();
      break;
    case "teljesjobb":
      revertRight();
      fullRight();
      break;
    case "teljesbal":
      revertLeft();
      fullLeft();
      break;
    default:
      break;
  }
}
